module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.menu), function(li) {
    return [(!li.permissions || _vm.checkAccess(li)) ? _c('li', {
      key: li.name,
      class: ("nav-item " + (li.children ? 'nav-dropdown' : ''))
    }, [(!li.children) ? _c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": li.url
      }
    }, [_c('i', {
      class: li.icon
    }), _vm._v(" " + _vm._s(li.name) + "\n          ")]) : [_c('div', {
      staticClass: "nav-link nav-dropdown-toggle",
      on: {
        "click": _vm.handleClick
      }
    }, [_c('i', {
      class: li.icon
    }), _vm._v(" " + _vm._s(li.name) + "\n            ")]), _vm._v(" "), _c('ul', {
      staticClass: "nav-dropdown-items"
    }, [_vm._l((li.children), function(nestedLi) {
      return [(_vm.checkNestedAccess(nestedLi, li)) ? _c('li', {
        key: nestedLi.name,
        staticClass: "nav-item"
      }, [_c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": nestedLi.url
        }
      }, [_c('i', {
        class: nestedLi.icon
      }), _vm._v(" " + _vm._s(nestedLi.name) + "\n                  ")])], 1) : _vm._e()]
    })], 2)]], 2) : _vm._e()]
  }), _vm._v(" "), _c('li', {
    key: "signout",
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signOut.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sign out\n        ")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6f55dec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 993
// module chunks = 0